module.exports = "/next-static/_next/static/images/editingSoftware-97b7033cb566bc38f880c23a60a5ae37.png";